import { Avatar, AvatarContent, AvatarDescription, AvatarImage } from '@playbooks/ui/components/avatar';
import { Link } from '@playbooks/ui/components/link';

export const CardAvatar = ({ thumbnail, title, text, href }) => (
	<Link variant='ghost' href={href} className='group h-auto p-0'>
		<Avatar className='flex-start'>
			<AvatarImage size='sm' src={thumbnail} alt={title} />
			<AvatarContent>
				<AvatarDescription className='hover:underline'>{title}</AvatarDescription>
			</AvatarContent>
		</Avatar>
	</Link>
);
